import type { StepProgressFlowConfig } from '@hunting-nature/shared-core/step-progress';
import { createFlowId, createStepId } from '@hunting-nature/shared-core/step-progress';

// Bump this id to show the walkthrough again for a new release (persisted per device once dismissed).
export const WHATS_NEW_ID = 'zeiss-hunt-v1.0';

export interface WhatsNewStep {
  readonly id: string;
  readonly image: string;
  readonly titleKey: string;
  readonly descriptionKey: string;
}

const IMAGE_BASE_PATH = 'assets/images/whats-new';

export const WHATS_NEW_STEPS: ReadonlyArray<WhatsNewStep> = [
  {
    id: 'what-stays',
    image: `${IMAGE_BASE_PATH}/what-stays.webp`,
    titleKey: 'whatsNew.steps.whatStays.title',
    descriptionKey: 'whatsNew.steps.whatStays.description',
  },
  {
    id: 'already-covered',
    image: `${IMAGE_BASE_PATH}/already-covered.webp`,
    titleKey: 'whatsNew.steps.alreadyCovered.title',
    descriptionKey: 'whatsNew.steps.alreadyCovered.description',
  },
  {
    id: 'newly-added',
    image: `${IMAGE_BASE_PATH}/newly-added.webp`,
    titleKey: 'whatsNew.steps.newlyAdded.title',
    descriptionKey: 'whatsNew.steps.newlyAdded.description',
  },
  {
    id: 'getting-developed',
    image: `${IMAGE_BASE_PATH}/getting-developed.webp`,
    titleKey: 'whatsNew.steps.gettingDeveloped.title',
    descriptionKey: 'whatsNew.steps.gettingDeveloped.description',
  },
];

export const WHATS_NEW_TOTAL_STEPS = WHATS_NEW_STEPS.length;

// Not routed, so baseRoute is unused — the progress indicator is driven by the explicit activeStep input instead.
export const WHATS_NEW_FLOW_CONFIG: StepProgressFlowConfig = {
  flowId: createFlowId('whats-new'),
  baseRoute: '',
  showProgressIndicator: true,
  steps: WHATS_NEW_STEPS.map((step, index) => ({
    id: createStepId(step.id),
    position: index + 1,
    showInProgress: true,
  })),
};
